<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Early Bird Deadlines</h1>
        </div>
        <div>
            Place your order on or before the Early Bird Deadline date with a
            minimum order of
            <el-input
                :readonly="!can(Permissions.EDIT_EARLY_BIRD)"
                min="0"
                style="width: 160px"
                type="number"
                v-model="form.min_order_amount"
            >
                <template slot="prepend">$</template>
            </el-input>
            to get FREE SHIPPING!!
        </div>
        <template v-for="(group, i) in form.groups">
            <div class="mt-30" v-if="group.id === 1">
                Group 1: 10 States plus District of Columbia: FL, LA, MS, AL,
                TN, KY, VA, NC, SC, GA, DC
                <div class="mt-10">
                    Early bird deadline is
                    <el-select
                        :disabled="!can(Permissions.EDIT_EARLY_BIRD)"
                        placeholder="Select..."
                        style="width: 100px"
                        v-model="group.deadline"
                    >
                        <el-option
                            v-for="date in dateOptions"
                            :key="date"
                            :label="date"
                            :value="date"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="mt-30" v-else-if="group.id === 2">
                Group 2: 38 States: AR, CT, DE, IL, IN, MD, MI, MO, NJ, OH, WV,
                OK, PA, TX, AZ, IA, KS, MA, ME, MN, NE, NH, NM, NY, RI, VT, WI,
                CA, CO, ND, NV, SD, UT, WY, ID, MT, OR, WA
                <div class="mt-10">
                    Early bird deadline is
                    <el-select
                        :disabled="!can(Permissions.EDIT_EARLY_BIRD)"
                        placeholder="Select..."
                        style="width: 100px"
                        v-model="group.deadline"
                    >
                        <el-option
                            v-for="date in dateOptions"
                            :key="date"
                            :label="date"
                            :value="date"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="mt-30" v-else>
                <div style="display: flex">
                    <div style="width: 400px">
                        Group {{ i + 1 }}: Corporate Specific
                    </div>
                    <div class="ml-10" style="width: 100px">Deadline</div>
                    <div class="ml-10" style="width: 170px">Minimum Amount</div>
                </div>
                <div style="display: flex">
                    <el-select
                        v-model="group.corporations"
                        multiple
                        placeholder="Select Corporations"
                        :disabled="!can(Permissions.EDIT_EARLY_BIRD)"
                        style="width: 400px"
                    >
                        <el-option
                            v-for="corp in corporations.data"
                            :key="corp.id"
                            :label="corp.name"
                            :value="corp.id"
                        >
                        </el-option>
                    </el-select>
                    <el-select
                        :disabled="!can(Permissions.EDIT_EARLY_BIRD)"
                        class="ml-10"
                        placeholder="Select..."
                        style="width: 100px"
                        v-model="group.deadline"
                    >
                        <el-option
                            v-for="date in dateOptions"
                            :key="date"
                            :label="date"
                            :value="date"
                        >
                        </el-option>
                    </el-select>
                    <el-input
                        :readonly="!can(Permissions.EDIT_EARLY_BIRD)"
                        class="ml-10"
                        min="0"
                        style="width: 170px"
                        type="number"
                        v-model="group.min_amount"
                    >
                        <template slot="prepend">$</template>
                    </el-input>
                </div>
            </div>
        </template>
        <p>Corporate settings override state settings.</p>
        <el-button
            :loading="form.busy"
            @click="submit()"
            icon="mdi mdi-content-save"
            type="primary"
            v-if="can(Permissions.EDIT_EARLY_BIRD)"
        >
            Save Changes
        </el-button>
    </vue-scroll>
</template>

<script>
import * as Actions from "@/store/constants/actions";
import { mapState } from "vuex";
import unsaved_changes_mixin from "@/mixins/unsaved-changes";
import auth from "@/mixins/auth";

export default {
    mixins: [unsaved_changes_mixin, auth],
    data() {
        return {
            form: new Form({
                min_order_amount: null,
                groups: [],
            }),
        };
    },
    created() {
        this.getData();
        this.$store.dispatch(Actions.FETCH_CORPORATIONS);
    },
    mounted() {},
    computed: {
        ...mapState(["corporations"]),
        dateOptions() {
            return _.range(1, 29);
        },
    },
    watch: {
        "form.min_order_amount"(value) {
            let ids = [1, 2];
            this.form.groups.forEach((group) => {
                if (_.includes(ids, group.id)) {
                    group.min_amount = value;
                }
            });
        },
    },
    methods: {
        getCleanFormData() {
            return JSON.stringify(
                _.pick(this.form, ["min_order_amount", "groups"])
            );
        },
        getData() {
            axios.get(`/web-api/early-bird`).then((response) => {
                this.form.min_order_amount = response.data.min_order_amount;
                this.form.groups = _.map(response.data.groups.data, (group) => {
                    let item = _.pick(group, [
                        "id",
                        "deadline",
                        "states",
                        "min_amount",
                    ]);
                    if (!item.states.data.length) {
                        item.corporations = _.map(
                            group.corporations.data,
                            (corp) => {
                                return corp.id;
                            }
                        );
                    }
                    return item;
                });
                this.initOldData();
            });
        },
        submit() {
            App.post(`/web-api/early-bird`, this.form).then(() => {
                this.$notify.success({
                    message: "Changes have been saved.",
                });
                this.initOldData();
            });
        },
    },
};
</script>

<style scoped></style>
